import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';

const routes: Routes = [
  {
    path: '',    
    component: BlankComponent,
    children: [
      {
        path: '',
        redirectTo: '/autenticacion/ingresar',
        pathMatch: 'full',
      },
      {
        path: 'autenticacion',
        loadChildren: () =>
          import('./apps/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      }      
    ],
  },
  {
    path: '',
    component: FullComponent,    
    children: [      
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'administracion',
        loadChildren: () =>
          import('./apps/pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: 'farmacia',
        loadChildren: () =>
          import('./apps/pages/farmacy/farmacy.module').then(
            (m) => m.FarmacyModule
          ),
      },
      {
        path: 'inventario',
        loadChildren: () =>
          import('./apps/pages/inventory/inventory.module').then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: 'almacen',
        loadChildren: () =>
          import('./apps/pages/warehouse/warehouse.module').then(
            (m) => m.WarehouseModule
          ),
      },
      {
        path: 'consulta',
        loadChildren: () =>
          import('./apps/pages/consulting/consulting.module').then(
            (m) => m.ConsultingModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./apps/pages/shared/shared.module').then(
            (m) => m.SharedModule
          ),
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.module').then(
            (m) => m.UicomponentsModule
          ),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.module').then((m) => m.FormModule),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.module').then((m) => m.AppsModule),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.module').then((m) => m.WidgetsModule),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.module').then((m) => m.TablesModule),
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.module').then(
            (m) => m.ThemePagesModule
          ),
      },
    ],
  },  
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
